import React from 'react'
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import { MuiDropDown } from "../../components/basicComponent/MuiDropDown";
import MuiButton from "../../components/basicComponent/MuiButton";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import { MuiInput } from "../../components/basicComponent/MuiInput";

const AgentProductiveAnalysis = () => {
  return (
    <div className="grow">
    <SideMenu />
    <div className="wrapper flex grow flex-col">
      <Header />
      <main className="grow content" id="content" role="content">
        <div className="container-fixed">
          <div className="card-header text-center">
            <h3 className="card-title">Agent Productive Analysis</h3>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card card-custom">
                <div className="card-body">
                  <div className="row mt-4">
                    <div className="col-md-4">
                      <MuiDatePicker
                        label="Booking From"
                        value={null}
                        onChange={function (date: string): void {
                          throw new Error("Function not implemented.");
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <MuiDatePicker
                        label="Booking To"
                        value={null}
                        onChange={function (date: string): void {
                          throw new Error("Function not implemented.");
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <MuiDropDown
                        label="Active From"
                        placeholder={"Active From"}
                        options={[]}
                        onChange={function (value: string, id: string): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiSearchSelect
                        label="Active To"
                        onChange={function (date: string): void {
                          throw new Error("Function not implemented.");
                        }}
                        placeholder={"Active To"}
                        options={[]}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiInput
                        label={"Branch"}
                        placeholder="Branch"
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiInput label={"Sales Person"} placeholder="Sales Person" />
                    </div>
                    <div className="col-md-4  mt-3">
                      <MuiInput
                        label="State "
                        placeholder={"State "}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiSearchSelect
                        label="Agent Type"
                        onChange={function (date: string): void {
                          throw new Error("Function not implemented.");
                        }}
                        placeholder={"Agent Type"}
                        options={[]}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiSearchSelect
                        label={"Agency Name/Agent ID"}
                        placeholder="Agency Name/Agent ID"
                        options={[]}
                        onChange={function (
                          value: string,
                          id: string,
                          data: any
                        ): void {
                          throw new Error("Function not implemented.");
                        }}
                        value={""}
                      />
                    </div>
                    <div className="col-md-4 mt-3"> 
                      <MuiInput
                        label={"Module"}
                        placeholder="Module"
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <MuiInput
                        label={"Product"}
                        placeholder="Product"
                      />
                    </div>    
                    

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        marginTop: "8px",
                      }}
                    >
                      <div className="user-button w-full">
                        <MuiButton
                          className="clear-btn "
                          label="Clear"
                          type="submit"
                        />
                        <MuiButton
                          label={"Get"}
                          className="main-btn get-btn"
                          variant="contained"
                          size="large"
                          type="submit"
                        />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
  )
}

export default AgentProductiveAnalysis
